// extracted by mini-css-extract-plugin
export default {"footer-container":"footer_footer-container__mTAsc","logo":"footer_logo__S-lXs"};